<template>
  <div>
    <div>
      <p v-html="one.description"></p>
      <br/>
      <v-textarea
        filled
        v-model="response"
        @change="$emit('update', {response, iso: one.iso})"
        @keydown="$emit('update', {response, iso: one.iso})"
      ></v-textarea>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    response: ''
  }),
  props: {
    cursor: Number,
    nbQuestions: Number,
    offerIso: String,
    one: Object
  },
  computed: {
    ...mapGetters('project', ['getResponse'])
  },
  mounted () {
    this.response = this.getResponse({iso: this.offerIso, question: this.one.iso})
  }
}
</script>